import React, { useCallback, useState } from "react";


  import moment from "moment";
  import Loader from "../../control-components/loader/loader";
  import { Grid, GridColumn } from "@progress/kendo-react-grid";
  import FilterModel from "./filter-model";
  import TruncatedCell from "./truncate-cell";



  
  
  const DATA_ITEM_KEY = "id";
  const SELECTED_FIELD = "selected";

  
  const Logs = () => {
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState([]);
    const [clients, setClients] = useState([]);
    const [total, setTotal] = useState(0);
    const [selectedState, setSelectedState] = useState({});
    const [finalValue, setFinalValue] = useState();
    const [selectedMasterClinicId, setSelectedMasterClinicId] = useState();
    const [skip, setSkip] = useState(0)
  
    const fetchFromParent = (message) => {
      setClients(message);
      setTotal(message.length);
      setPage(1);
      setSkip(0);

    };
  
    const pageChange = (event) => {
      const skip = event.page.skip;
      const take = event.page.take;
      setSkip(skip);
      setPage(skip / take + 1);
      setPageSize(take);
    };
   
  
    const handleSelectedMasterClinicIdChange = useCallback((clientId) => {
      setSelectedMasterClinicId(clientId);
    }, []);
  
  
    return (
      <>
        <h4 className="address-title text-grey">
          <span className="f-24">Logs</span>
        </h4>
        <div className="row">
          <FilterModel
            page={page}
            pageSize={pageSize}
            finalValue={finalValue}
            fetchFromParent={fetchFromParent}
            setLoading={setLoading}
            onMasterClinicIdChange={handleSelectedMasterClinicIdChange}
          />
        </div>
        <div className="grid-table filter-grid">
        
          <div className="mt-3">
         
            <div className="inner-section-edit position-relative text-center">
              <div className="grid-table filter-grid header-blue">
                <div className="mt-3">
                
               {loading === true ? <Loader />
               :   <Grid
                                data={clients.slice(skip, skip + pageSize)}
                                skip={skip}
                                take={pageSize}
                                onPageChange={pageChange}
                                total={total}
                                pageable={{
                                   pageSizes: [10, 25, 50, 100, 250, 500],
                                }}
                                selectedField={SELECTED_FIELD}
                                dataItemKey={DATA_ITEM_KEY}
                                sort={sort}
                                sortable={true}
                                // onSortChange={(e) => {
                                //    if (e.sort) {
                                //       setSort(e.sort);
                                //    }
                                // }}
                    >
                    
                    
                    <GridColumn
                      field="callsite"
                      title="Callsite"
                      width="300"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn
                      field="exception"
                      title="Exception"
                      width="300"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn
                      field="request"
                      title="Request"
                      width="300"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn
                      field="identifier"
                      title="Error Id"
                      width="250"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn field="url" title="URL" width="250" cells={{
                      data: TruncatedCell
                    }} />
                    <GridColumn
                      field="querystring"
                      title="Querystring"
                      width="250"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn
                      field="region"
                      title="Region"
                      width="150"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn
                      field="staffId"
                      title="Staff Id"
                      width="150"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    <GridColumn
                      field="clinicId"
                      title="Clinic Id"
                      width="150"
                      cells={{
                        data: TruncatedCell
                      }}
                    />
                    
                    <GridColumn field="level" title="Level" width="150" cells={{
                      data: TruncatedCell
                    }} />
                    <GridColumn
                      field="datetime"
                      title="Date"
                      width="250"
                      cells={{
                        data: (props) => {
                          const field = moment(props.dataItem.datetime).format(
                            "MM/DD/YYYY"
                          );
                          return <td className="cursor-default">{field}</td>;
                        }
                      }}
                    />
                  </Grid>
  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  
  export default Logs;
